export const spaceName = 'odSettingBusiness';

export interface BusinessSettings {
  originBasicInfo: any;
  currentBasicInfo: any;
  relationData: any;
  activeTabKey: any;

  originPaymentInfo: any;
  currentPaymentInfo: any;

  originBusinessMeta: any;
  currentBusinessMeta: any;

  originAvailableHours: any;
  currentAvailableHours: any;

  originStockSettings: any;
  currentStockSettings: any;

  originSplitCharge: {
    splitSurcharge: string;
    isActive: 0 | 1;
  };
  currentSplitCharge: {
    splitSurcharge: string;
    isActive: 0 | 1;
  };

  originEnableTipsProcessingFee: boolean;
  currentEnableTipsProcessingFee: boolean;

  showRecurringStockModal: {
    show: boolean;
    key?: 'edit';
  };
  editingStock: number;
  activeStockTab: 'daily' | 'recurring';
}

export default {
  showRecurringStockModal: {
    show: false,
  },
  activeStockTab: 'daily',
} as BusinessSettings;
